import type { FullParcel } from '@coig/apm-api/dist/models/FullParcel';

export const states = (status: FullParcel['status'], side: 'receiver'|'sender') => {
  if (status === 'READY_TO_SEND') {
    return 'Ready to ship';
  }
  if (status === 'SENT') {
    return 'Sent';
  }
  if (status === 'TRANSPORT') {
    return 'In transport';
  }
  if (status === 'READY_TO_RECEIVE') {
    return 'Ready to take';
  }
  if (status === 'RECEIVED') {
    if (side === 'receiver'){
      return 'Taken out';
    }
    return 'Given';
  }

};
